var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.appointment.reasons && _vm.appointment.reasons.length > 0
        ? _c("div", { staticClass: "font-weight-bold" }, [
            _vm._v(
              "\n\t\t" + _vm._s(_vm.appointment.reasons.join(", ")) + "\n\t"
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.isTypeEligible
        ? _c("div", { staticClass: "mt-1" }, [
            _vm.appointment.type === _vm.types.videoCall
              ? _c("div", [_vm._v("Video-Telefonat")])
              : _vm._e(),
            _vm._v(" "),
            _vm.appointment.type === _vm.types.phoneCall
              ? _c(
                  "div",
                  [
                    _vm.isTypeApplicant
                      ? [
                          _vm._v(
                            "\n\t\t\t\tTelefonat (Du wirst angerufen unter der von dir angegebenen Mobilnummer:\n\t\t\t\t"
                          ),
                          _c("b", [
                            _vm._v(_vm._s(_vm.appointment.phone.formatted))
                          ]),
                          _vm._v(
                            " - Deine Rufnummer wird kurz vor dem Termin an den\n\t\t\t\tGesprächspartner weitergegeben.)\n\t\t\t"
                          )
                        ]
                      : [_vm._v("Telefonat")]
                  ],
                  2
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.appointment.onlineActivity
              ? _c("div", [
                  _vm._v("\n\t\t\tOnlinetätigkeit\n\t\t\t"),
                  _vm.appointment.onlineActivityExecution
                    ? _c("span", [
                        _vm._v("(" + _vm._s(_vm.onlineActivityExecution) + ")")
                      ])
                    : _vm._e()
                ])
              : _vm._e()
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.appointment.duration
        ? _c("div", { staticClass: "font-weight-bold mt-1" }, [
            _vm._v("Dauer ungefähr " + _vm._s(_vm.appointment.duration))
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.appointment.location
        ? _c("div", { staticClass: "font-weight-bold mt-1" }, [
            _vm._v(_vm._s(_vm.appointment.location))
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.appointment.participants && _vm.appointment.participants.length > 0
        ? _c(
            "div",
            { staticClass: "mt-1" },
            [
              _c("div", [_vm._v("Mit:")]),
              _vm._v(" "),
              _vm._l(_vm.appointment.participants, function(participant, i) {
                return _c(
                  "div",
                  { key: "participant-" + i, staticClass: "font-weight-bold" },
                  [_vm._v("\n\t\t\t" + _vm._s(participant) + "\n\t\t")]
                )
              })
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.isTypeCustomer
        ? [
            _vm.appointment.phone
              ? _c("div", { staticClass: "font-weight-bold mt-1" }, [
                  _c(
                    "a",
                    { attrs: { href: "tel:" + _vm.appointment.phone.full } },
                    [_vm._v(_vm._s(_vm.appointment.phone.formatted))]
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.appointment.linkEligible
              ? _c("div", { staticClass: "font-weight-bold mt-1" }, [
                  _vm.sentAccessLink
                    ? _c(
                        "span",
                        [
                          _c("Icon", {
                            staticClass: "mr-1",
                            attrs: { icon: "checkmark", color: "green" }
                          }),
                          _vm._v("\n\t\t\t\tZugangsdaten gesendet\n\t\t\t\t"),
                          _c(
                            "a",
                            {
                              staticClass: "ml-1",
                              attrs: { href: "#" },
                              on: {
                                click: function($event) {
                                  _vm.sendAccessLink = true
                                }
                              }
                            },
                            [
                              _c("Icon", {
                                attrs: { icon: "edit", color: "primary" }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _c(
                        "a",
                        {
                          staticClass: "font-size-smaller",
                          attrs: { href: "#" },
                          on: {
                            click: function($event) {
                              $event.preventDefault()
                              _vm.sendAccessLink = true
                            }
                          }
                        },
                        [
                          _c("Icon", {
                            staticClass: "mr-2",
                            attrs: {
                              icon: "key-chain",
                              color: "primary",
                              size: "1comma5x"
                            }
                          }),
                          _vm._v("\n\t\t\t\tZugangsdaten (Link) senden\n\t\t\t")
                        ],
                        1
                      )
                ])
              : _vm._e()
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.isTypeApplicant &&
      _vm.appointment.linkEligible &&
      _vm.appointment.accessLink
        ? _c("div", { staticClass: "mt-2" }, [
            _c("div", [
              _c(
                "a",
                {
                  attrs: { href: _vm.appointment.accessLink, target: "_blank" }
                },
                [
                  _vm._v(
                    "\n\t\t\t\tKlicke hier um den Link der Firma zu öffnen\n\t\t\t"
                  )
                ]
              )
            ]),
            _vm._v(" "),
            _vm.appointment.accessLinkUsername
              ? _c("div", [
                  _vm._v(
                    "\n\t\t\tBenutzername: " +
                      _vm._s(_vm.appointment.accessLinkUsername) +
                      "\n\t\t"
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.appointment.accessLinkPassword
              ? _c("div", [
                  _vm._v(
                    "\n\t\t\tPasswort: " +
                      _vm._s(_vm.appointment.accessLinkPassword) +
                      "\n\t\t"
                  )
                ])
              : _vm._e()
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.isTypeApplicant &&
      _vm.appointment.linkEligible &&
      !_vm.appointment.accessLink
        ? _c("JonInfo", {
            staticClass: "mt-2",
            scopedSlots: _vm._u(
              [
                {
                  key: "message",
                  fn: function() {
                    return [
                      _vm.appointment.type === _vm.types.videoCall
                        ? [
                            _vm._v(
                              "\n\t\t\t\tZugangsdaten zum Videoanruf erhältst du nach der Terminvereinbarung von der Firma.\n\t\t\t"
                            )
                          ]
                        : [
                            _vm._v(
                              "\n\t\t\t\tZugangsdaten erhältst du nach der Terminvereinbarung von der Firma.\n\t\t\t"
                            )
                          ]
                    ]
                  },
                  proxy: true
                }
              ],
              null,
              false,
              542333045
            )
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.sendAccessLink
        ? _c("SendAccessLinkPopUp", {
            attrs: { appointment: _vm.appointment },
            on: {
              sent: _vm.onSentAccessLink,
              hidden: function($event) {
                _vm.sendAccessLink = false
              }
            }
          })
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }